import { AppBar, Box, IconButton, Toolbar, Typography, styled, Button } from '@mui/material'
import { Add } from '@mui/icons-material';
import { auth } from '../../config/firebase';
import { signOut } from 'firebase/auth';

const MyToolbar = styled(Toolbar)(({ theme }) => ({
    display: "flex",
    justifyContent: "space-between"
}))

const Icons = styled(Box)(({ theme }) => ({
    display: "flex", gap: "5px", alignItems: "center"
}))

interface ChildProps {
    add: () => void;
}

const NavBarAdmin = (props: ChildProps) => {
    return (
        <AppBar position='sticky'>
            <MyToolbar>
                <Typography variant='h6'>
                    akhilasdeveloper admin
                </Typography>
                <Icons>
                    <IconButton aria-label="add" onClick={props.add}>
                        <Add />
                    </IconButton>
                    <Button color="secondary" onClick={() => {
                        signOut(auth)
                    }}>Sign Out</Button>
                </Icons>
            </MyToolbar>
        </AppBar>
    )
}
export default NavBarAdmin
